export enum LayoutVisaoEnum {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
  NOTEBOOK = 'notebook'
}
